(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-carousel"] && !Shopify.designMode) return;
  try {
    
  setsize();
  window.addEventListener("resize", setsize);
  function setsize() {      
    if ($(window).width() <= 1007) {    
      let d =document.getElementsByClassName("CollectionList--carousel")[0];      
      console.log("mkl window width",$(window).width());      
      if (d){
        d.classList.add("CollectionList");
        d.classList.remove("CollectionList--carousel");
      }
     } else {
      let d =document.getElementsByClassName("CollectionList")[0];
      console.log("mkl window width",$(window).width());      
      if(d) {
        d.classList.add("CollectionList--carousel");
        d.classList.remove("CollectionList");    
      }
    }
 }

  } catch(e) { console.error(e); }
})();
})();
